import React from 'react'
import { Modal, Form } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileDownload, faPaperclip } from '@fortawesome/pro-solid-svg-icons'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'

import * as fromActions from 'store/actions/lms-profiles.action'
import Button from 'design-system/button'
import { ButtonSizes, ButtonVariant } from 'design-system/button/src/Button'
import styles from './UploadModal.module.scss'

interface IProps {
  show: boolean
  setShow: (state: boolean) => void
}

const UploadModal: React.FC<IProps> = ({ show, setShow }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const handleClose = () => setShow(false)

  const handleFileUpload = (e: any) => {
    const [file] = e.target.files
    dispatch({ type: fromActions.LMS_PROFILES_UPLOAD, payload: file })
    setShow(false)
  }

  return (
    <Modal size="lg" show={show} onHide={handleClose} centered>
      <Modal.Header translate="yes" closeButton className="ml-3 mr-3 mt-2 pb-2">
        <Modal.Title>
          <p className={styles.headFont}>
            {t('configuration.lmsProfiles.upload.modal.title')}
          </p>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="ml-3 mr-3">
        <p>{t('configuration.lmsProfiles.upload.modal.legend')}</p>
        <Modal.Dialog size="lg" className="pt-1 mb-2">
          <Form className={styles.inputDesing}>
            <Form.Group>
              <input
                className={styles.inputfile}
                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                id="customFile"
                type="file"
                onChange={handleFileUpload}
              />
              <Form.Label htmlFor="customFile">
                <FontAwesomeIcon icon={faPaperclip} />{' '}
                {t('configuration.users.upload.modal.addFile')}
              </Form.Label>
            </Form.Group>
          </Form>
        </Modal.Dialog>
        <div className="float-right">
          <a
            className={styles.bodyFont}
            target="_blank"
            href="https://rankmi-lms-prod.s3.amazonaws.com/templates/2+-+Template+de+carga+y+descarga+masiva+perfiles+LMS.xlsx"
          >
            <span>{t('configuration.users.upload.modal.template')}</span>
            <FontAwesomeIcon
              icon={faFileDownload}
              className="mt-2 ml-2"
            ></FontAwesomeIcon>
          </a>
        </div>
      </Modal.Body>
      <Modal.Footer className="ml-3 mr-3 mt-2">
        <Button
          variant={ButtonVariant.Secondary}
          size={ButtonSizes.Small}
          onClick={handleClose}
        >
          {t('commons.buttons.close')}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default UploadModal
